import React, { useState, useContext } from "react";

import PlusIcon from "../../icons/plus-icon";
import BalanceIcon from "../../icons/balance-icon";
import LoanIcon from "../../icons/loan-icon";

import { PopUpContext } from "../../contexts/popUpContext";

import lbl from "../../data/Labels.json";

const FabButtons = ({ cache }) => {
  const [open, setOpen] = useState(false);
  const { togglePopUp } = useContext(PopUpContext);

  return (
    <div className={`fab-container ${open ? "active" : ""}`}>
      <button
        className="secondary"
        onClick={() => togglePopUp({ form: "contractor-balance-form", cache })}
      >
        <BalanceIcon />
        <span>{lbl.OpeningBalance}</span>
      </button>

      <button
        className="secondary"
        onClick={() => togglePopUp({ form: "contractor-payable-form", cache })}
      >
        <LoanIcon />
        <span>{lbl.Payable}</span>
      </button>

      <button className="primary" onClick={() => setOpen(!open)}>
        <PlusIcon />
        <span>{lbl.Cancel}</span>
      </button>
    </div>
  );
};

export default FabButtons;
